import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/user/functions.vue'
wx.createPage(MiniProgramPage)